<template>
	<div>
		<div class="w-100p h-850 bgimg m-t-70 hidden-xs-only">
			<div class="fu w-500 p-30">
				<div class="f-24 c-00 d-flex-center font-weight-bold">润寓账号注册</div>
				<div class="m-t-55 h-50">
					<el-input v-model="tel" placeholder="手机号" maxlength="11" clearable></el-input>
				</div>
				<div class="m-t-20 h-50">
					<el-input v-model="password" placeholder="密码" show-password clearable></el-input>
				</div>
				<div class="m-t-20 h-50">
					<el-input v-model="password1" placeholder="确认密码" show-password clearable></el-input>
				</div>
				<div class="m-t-20 h-50 d-flex-row">
					<el-input class="m-r-15" v-model="code" placeholder="验证码" clearable></el-input>
					<div v-if="isShow" @click="obtain"
						class="f-16 c-white w-50p bgc-EA4638 d-flex-center d-flex-items-center">
						获取验证码
					</div>
					<div v-else class="f-16 c-white w-50p bgc-EA4638 d-flex-center d-flex-items-center">
						{{count}}秒
					</div>
				</div>
				<div class="m-t-20">
					<div @click="submit" class="f-16 h-50 c-white bgc-EA4638 d-flex-center d-flex-items-center">
						立即注册
					</div>
				</div>
				<div class="m-t-20 d-flex-between d-flex-center f-14 c-66">
					<div @click="go('/login')">已有账号,去登录</div>
				</div>
			</div>
		</div>
		<div class="hidden-sm-and-up">
			<phone></phone>
		</div>
	</div>
</template>

<script>
	import phone from '../../components/phone.vue'
	export default {
		components: {
			phone
		},
		data() {
			return {
				password: "",
				password1: "",
				tel: "",
				code: "",
				isShow: true,
				count: ''
			}
		},
		mounted() {

		},
		methods: {
			go(url) {
				this.$router.push(url)
			},
			verification() {
				this.isShow = false; //倒计时
				this.count = 60; //赋值3秒
				var times = setInterval(() => {
					this.count--; //递减
					if (this.count <= 0) {
						// <=0 变成获取按钮
						this.isShow = true;
						clearInterval(times);
					}
				}, 1000); //1000毫秒后执行
			},
			async obtain() {
				if (this.tel == "") {
					this.$message.error('请填写手机号')
					return
				}
				const myreg = /^1[3-9]\d{9}$/;
				if (!myreg.test(this.tel)) {
					this.$message.error('手机号格式不正确')
					return
				}
				const res = await this.$service.post({
					url: '/api/web/v1/app_send_code',
					data: {
						mobile: this.tel,
						scene:"web_register",
					}
				})
				if (res.code === 1) {
					this.verification()
				} else {
					this.$message.error(res.msg)
				}
			},
			async submit() {
				if (this.password == "" || this.password1 == "") {
					this.$message.error('密码不为空')
					return
				}
				if (this.password != this.password1) {
					this.$message.error('请重新确认密码')
					return
				}
				if (this.tel == "") {
					this.$message.error('请输入手机号')
					return
				}
				const myreg = /^1[3-9]\d{9}$/;
				if (!myreg.test(this.tel)) {
					this.$message.error('手机号格式不正确')
					return
				}
				if (this.code == "") {
					this.$message.error('请输入验证码')
					return
				}
				const res = await this.$service.post({
					url: '/api/web/v1/app_register',
					data: {
						mobile: this.tel,
						password: this.password,
						mobile_code: this.code
					}
				})
				if (res.code === 1) {
					this.$router.push("/login")
				} else {
					this.$message.error(res.msg)
				}

			}
		}
	}
</script>

<style scoped>
	.bgimg {
		background: url('../../assets/image/login/login.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}

	.fu {
		position: relative;
		top: 10%;
		left: calc(90% - 500px);
		background: rgba(255, 255, 255, 0.90);
	}
</style>
<style>
	.el-input__inner {
		height: 50px !important;
		line-height: 50px !important;
	}
</style>
